import { Item } from './item-data-store';
import * as itemSelectors from './selectors';

export const byRealTimeLocation = (a: Item, b: Item) => {
    const aRealTimeLocation = itemSelectors.realTimeLocation(a as Item) || '';
    const bRealTimeLocation = itemSelectors.realTimeLocation(b as Item) || '';
    return bRealTimeLocation.localeCompare(aRealTimeLocation);
};
